import React, { useEffect, useRef, useState } from "react";
import Skeleton from "react-loading-skeleton";
import imgNotFound from "../../../../assets/images//single-image.png";
import NoDataFound from "../../../NoDataFound/NoDataFound";
import styles from "./NewUiSinglePackage.module.scss";
import { SvgLocation, SvgTick } from "../../../../utils/svgIcons";

const NewUiSinglePackageAccommodation = ({
  singlePackageData,
  setSelectedCategory,
  selectedCategory,
  setSelectedMealPlan,
  selectedMealPlan,
  loader,
  allPackageHotels,
  packageRates,
  ratesOfPackages,
  // roomsDetails,
  // setRoomsDetails
}) => {
  const [expandedCard, setExpandedCard] = useState(selectedCategory);
  const [selectedCard, setSelectedCard] = useState(0);
  const sectionRef = useRef(null);


  const toggleCard = (index, e) => {
    e.stopPropagation();
    if (expandedCard === index) {
      setExpandedCard(null); // Collapse the card if it's already open
    } else {
      setExpandedCard(index); // Expand the clicked card
    }
  };

  const toggleSelect = (index, category) => {
    setSelectedCard(index); // Toggle the selected card
    setSelectedCategory(category);
    setExpandedCard(category);
    window.scrollTo({ top: 0, behavior: "smooth" });
  };

  // const groupByCategory = (accommodations) => {
  //   return (
  //     accommodations &&
  //     accommodations?.reduce((acc, accommodation) => {
  //       const category = accommodation.hotelcategory;
  //       if (!acc[category]) {
  //         acc[category] = [];
  //       }
  //       acc[category].push(accommodation);
  //       return acc;
  //     }, {})
  //   );
  // };

  const groupByCategory = (accommodations) => {
    if (!accommodations) return {};

    const grouped = accommodations.reduce((acc, accommodation) => {
      const category = accommodation.hotelcategory;
      if (!acc[category]) {
        acc[category] = [];
      }
      acc[category].push(accommodation);
      return acc;
    }, {});

    // Sort the categories to ensure "Deluxe" is first
    const sortedCategories = Object.keys(grouped).sort((a, b) => {
      if (a === selectedCategory) return -1; // Move "Deluxe" to the top
      if (b === selectedCategory) return 1; // Keep "Deluxe" above other categories
      return 0; // Maintain the existing order for others
    });

    // Reconstruct the grouped object with "Deluxe" first
    return sortedCategories.reduce((sortedAcc, category) => {
      sortedAcc[category] = grouped[category];
      return sortedAcc;
    }, {});
  };

  useEffect(() => {
    if (!singlePackageData || !selectedCategory || !allPackageHotels) {
      console.error(
        "Missing data: singlePackageData or selectedCategory is undefined."
      );
      return;
    }

    const groupedData = groupByCategory(allPackageHotels);

    if (!groupedData || !groupedData[selectedCategory]) {
      console.error(
        `Error: groupByCategory returned undefined or no data for category ${selectedCategory}.`
      );
      return;
    }

    const selectedArray = groupedData[selectedCategory];

    if (selectedArray.length === 0) {
      console.warn(
        `No data found for the selected category: ${selectedCategory}`
      );
      return;
    }

    // const findMealPlan = selectedArray[0]?.accommodationMealPlan;

    if (selectedMealPlan) {
      // setSelectedMealPlan(selectedMealPlan);
    } else {
      console.warn("No meal plan found in the selected category.");
    }
  }, [selectedCategory, singlePackageData]);

  const data = groupByCategory(allPackageHotels);
  const setMealPlan = (selectedMealPlanObj) => {
    const findObj = packageRates.find(
      (rate) => rate.accommodationType === selectedMealPlanObj
    );
    if (!findObj) {
      setSelectedMealPlan(selectedMealPlan);
      return;
    }
    // setSelectedMealPlan(findObj?.mealPlan)
  };

  const handleCategoryClick = (category) => {
    setSelectedCategory(category);
    sectionRef?.current?.scrollIntoView({ behavior: "smooth", block: "start" });

    setTimeout(() => {
      window.scrollBy({ top: -80, behavior: "smooth" });
    }, 100);
  };

  return (
    <div ref={sectionRef}>
      {loader ? (
        <div className="package-update-content-containers" >
          <div>
            {Array.from({ length: 3 }).map((_, index) => (
              <div className="package-update-card">
                <div className="p_15">
                  <Skeleton width={100} />
                </div>
                <div
                  className="content-consider"
                  style={{
                    display: "flex",
                    flexWrap: "wrap",
                    gap: "10px",
                    maxHeight: "1000px",
                    overflow: "hidden",
                  }}
                >
                  {Array.from({ length: 5 }).map((_, index) => (
                    <div
                      className="card-content"
                      style={{
                        width: "calc(33.33% - 10px)",
                        boxSizing: "border-box",
                        border: "1px solid rgb(221, 221, 221)",
                        padding: "10px",
                      }}
                    >
                      <Skeleton height={150} width={225} />
                      <Skeleton width={80} />
                      <div className="flex justify_content_between">
                        <Skeleton width={50} />
                        <Skeleton width={30} />
                      </div>
                    </div>
                  ))}
                </div>
              </div>
            ))}
          </div>
        </div>
      ) : (
        <>
          {allPackageHotels && allPackageHotels.length > 0 ? (
            <div style={{ backgroundColor: "#fff" }} >
              {Object.keys(groupByCategory(allPackageHotels)).map(
                (category, index) => (
                  <div
                    key={index}
                    className="package-update-card p_top_0"
                    style={{
                      transition: "height 0.3s ease-out",
                      backgroundColor: "#",
                    }}
                  >
                    <div
                      className="flex p_15"
                      style={{
                        display: "flex",
                        justifyContent: "space-between",
                        alignItems: "center",
                        gap: "10px",
                      }}
                    // onClick={(e) => toggleCard(category, e)}
                    >
                      <div
                        style={{
                          display: "flex",
                          alignItems: "center",
                          cursor: "pointer",
                        }}
                      >
                        {/* <svg
                          width="15"
                          height="15"
                          viewBox="0 0 9 5"
                          fill="none"
                          xmlns="http://www.w3.org/2000/svg"
                          style={{
                            cursor: "pointer",
                            transform:
                              expandedCard === category
                                ? "rotate(180deg)"
                                : "rotate(0deg)",
                            transition: "transform 0.3s",
                          }}
                        >
                          <path
                            d="M8.25 0.75L4.75 4.25L1.25 0.75"
                            stroke="#000"
                          />
                        </svg>{" "} */}
                        <div
                          className="flex text-capitalize"
                          style={{
                            alignItems: "center",
                            gap: "4px",
                            fontSize: "14px",
                            textTransform: "upperCase",
                            fontWeight: "500",
                          }}
                        >
                          {" "}
                          {category}
                        </div>
                      </div>
                      {/* {selectedCategory === category && (
                        <div
                          style={{ cursor: "pointer", color: "#016932", padding: "4px 5px", backgroundColor: "#009A50", color: "#fff" }}
                        >
                          <SvgTick style={{ marginRight: "5px" }} />
                          Selected
                        </div>
                      )} */}

                      {selectedCategory === category ? (
                        <div
                          style={{ cursor: "pointer", padding: "4px 5px", backgroundColor: "transparent", border: '1px solid #009A50', color: "#009A50", textTransform: 'uppercase', fontSize: '12px', fontWeight: 500 }}
                        >
                          <svg xmlns="http://www.w3.org/2000/svg" width="14" height="15" viewBox="0 0 14 15" fill="none">
                            <mask id="mask0_6890_8246" maskUnits="userSpaceOnUse" x="0" y="0" width="14" height="15">
                              <rect y="0.5" width="14" height="14" fill="#D9D9D9" />
                            </mask>
                            <g mask="url(#mask0_6890_8246)">
                              <path d="M5.57075 9.3375L10.5145 4.39375C10.6312 4.27708 10.7673 4.21875 10.9228 4.21875C11.0784 4.21875 11.2145 4.27708 11.3312 4.39375C11.4478 4.51042 11.5062 4.64896 11.5062 4.80937C11.5062 4.96979 11.4478 5.10833 11.3312 5.225L5.97908 10.5917C5.86242 10.7083 5.72631 10.7667 5.57075 10.7667C5.41519 10.7667 5.27908 10.7083 5.16242 10.5917L2.65408 8.08333C2.53742 7.96667 2.48151 7.82812 2.48638 7.66771C2.49124 7.50729 2.552 7.36875 2.66867 7.25208C2.78533 7.13542 2.92388 7.07708 3.08429 7.07708C3.24471 7.07708 3.38325 7.13542 3.49992 7.25208L5.57075 9.3375Z" fill="#009A50" />
                            </g>
                          </svg>
                          Selected
                        </div>
                      ) : (
                        <div
                          onClick={() => handleCategoryClick(category)}
                          // onClick={(e) => setSelectedCategory(category)}
                          style={{ cursor: "pointer", color: "#fff", padding: "4px 10px", backgroundColor: "#009A50", textTransform: 'uppercase', }}
                        >
                          Select
                        </div>
                      )}
                    </div>
                    <div
                      className="accomodation_card"
                      style={{
                        display: "flex",
                        gap: "10px",
                        // maxHeight: expandedCard === category ? "1000px" : "0",
                        // overflow: "hidden",
                        transition: "max-height 0.3s ease-out",
                      }}
                    >
                      {groupByCategory(allPackageHotels)[category]?.map(
                        (itemData, itemIndex) => {
                          return (
                            <div
                              key={itemIndex}
                              className={` ${styles.accommodation_card} accomodation_img`}
                            >
                              <img
                                src={
                                  itemData.featuredImage
                                    ? itemData.featuredImage
                                    : imgNotFound
                                }
                                style={{
                                  width: "100%",
                                  // height: "240px",
                                  objectFit: "cover",
                                }}
                                alt={`Image ${itemIndex + 1}`}
                              />

                              <div
                                className={`${styles.heading_mobile} flex align_items_center justify_content_between flex_wrap p_15`}
                              >
                                <div>
                                  <div className="font_12 flex align_items_center ">
                                    <span className="flex align_items_center">
                                      <SvgLocation />
                                    </span>{" "}
                                    <span className="color_333 weight_300">
                                      {itemData.city}
                                    </span>{" "}
                                  </div>
                                  <h6 className="font_16 weight_500">
                                    {itemData.name}
                                  </h6>
                                </div>
                                {/* <p className="font_12">
                                  {itemData.starRating} Stars
                                </p> */}
                              </div>

                              {/* <div className="flex align_items_center justify_content_between"> */}
                              {/* <div className={`${styles.remove_in_mobile} flex py-5 flex_gap_5`}>
                                <b className="font_12">Meal Plan: </b>
                                <p className="text-uppercase font_12">
                                  {" "}
                                  {selectedMealPlan}
                                </p>
                              </div>
                              <div className={`${styles.remove_in_mobile} flex flex_gap_5`}>
                                <b className="font_12">Room Category:</b>{" "}
                                <p className="text-capitalize font_12 text_right">
                                  {itemData?.roomDetails[0]?.name}
                                </p>
                              </div> */}
                              {/* </div> */}
                            </div>
                          );
                        }
                      )}
                      {/* <hr style={{marginTop:"10px"}} /> */}
                    </div>
                  </div>
                )
              )}
            </div>
          ) : (
            <NoDataFound />
          )}
        </>
      )}
    </div>
  );
};

export default NewUiSinglePackageAccommodation;
